
















































































































































































import { Vue, Component } from 'vue-property-decorator'
import Title from '@/components/PageTitle.vue'
const range = (length: number, start = 0) => Array.from({ length }, (_, i) => i + start)
@Component({
  components: {
    Title
  }
})
export default class CreditCardPaymentProcess extends Vue {
  private payLimit = 'once'
  private inputValue = ['', '', '', '']
  private monthOptions = range(12, 1)
  private yearOptions = range(12, new Date().getFullYear() - 6)
  private yearInput = -1
  private monthInput = -1
  private securityCode = ''
  private email = ''
  private contractConfirm = false

  private payLimitHasError = false
  private cardNumHasError = false
  private validMonthHasError = false
  private validYearHasError = false
  private securityCodeHasError = false
  private emailHasError = false

  onInput (col: number) {
    return () => {
      let num: any = this.$refs['col-' + col]
      num = num.value
      console.log(num)
      if (col !== 4 && ('' + num).length === 4) {
        let ref: any = this.$refs['col-' + (col + 1)]
        ref.focus()
      } else if (col === 4 && this.inputValue[col - 1].length > 4) {
        this.inputValue[col - 1] = this.inputValue[col - 1].substring(0, 4)
        this.cardNumIsValid()
      }
    }
  }
  get cardIs () {
    if (this.inputValue[0].length < 4) return 'none'
    if (this.inputValue[0].startsWith('4')) return 'visa'
    if (+(this.inputValue[0].slice(0, 2)) <= 55 && +(this.inputValue[0].slice(0, 2)) >= 51) return 'master'
    if (this.inputValue[0] === '1800' || this.inputValue[0] === '2131' || (+(this.inputValue[0].slice(0, 3)) >= 300 && +(this.inputValue[0].slice(0, 3)) < 400)) {
      return 'jcb'
    }
    return 'none'
  }
  cardNumIsValid () {
    this.cardNumHasError = !this.inputValue.every(e => e.length === 4)
  }
  cardBlurCheck (index = 0) {
    this.cardNumHasError = this.inputValue[index].length !== 4
  }

  yearCheck () {
    this.validYearHasError = this.yearInput === -1
  }

  monthCheck () {
    this.validMonthHasError = this.monthInput === -1
  }

  secureityCodeCheck () {
    this.securityCodeHasError = this.securityCode.length !== 3
  }

  emailCheck () {
    this.emailHasError = !/.+@.+\..+/.test(this.email)
  }

  onConfirmClick () {
    this.cardNumIsValid()
    this.yearCheck()
    this.monthCheck()
    this.secureityCodeCheck()
    this.emailCheck()
    if (this.cardNumHasError || this.validYearHasError || this.validMonthHasError || this.securityCodeHasError || this.emailHasError) {
      return false
    } else {
      return true
    }
  }
}
